var isObject = require('../internals/is-object');

var anObject = require('../internals/an-object');

module.exports = function (O, proto) {
  anObject(O);

  if (!isObject(proto) && proto !== null) {
    throw TypeError("Can't set " + String(proto) + ' as a prototype');
  }
};